import { render, staticRenderFns } from "./RoleUser.vue?vue&type=template&id=7b790f9e&scoped=true"
import script from "./RoleUser.vue?vue&type=script&lang=js"
export * from "./RoleUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b790f9e",
  null
  
)

export default component.exports